module.exports = __webpack_public_path__ + "static/media/BLUE_TREE_TOWERS_ANALIA_FRANCO.9a485231.png";